import toast from "react-hot-toast";
import { formatDateDb } from "../../utils/tools";

const { clientAPI } = require("../client");
export const customerCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/customer", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  createBusiness: async (data) => {
    try {
      const response = await clientAPI("post", "/customer/business", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/customer/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateBusiness: async (id, data) => {
    try {
      const response = await clientAPI("put", `/customer/business/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/customer/${id}`);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  share: async (id, data) => {
    try {
      const response = await clientAPI("put", `/customer/shares/${id}`, data);
      return response;
    } catch (error) {
      console.error("Shares error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getById: async (id) => {
    try {
      const response = await clientAPI("get", `/customer/${id}`);
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  import: async (input, name) => {
    try {
      const response = await clientAPI("post", "/customer/import", {
        input,
        name,
      });
      return response;
    } catch (error) {
      console.error("Import error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (optionsData) => {
    try {
      const options = { ...optionsData };

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/customer?${queryParams}`);

      const dataExport = (response?.items || []).reduce((acc, item) => {
        let permanentAddress = item?.permanentAddress || "";
        if (item.permanentAddressWardData) {
          permanentAddress += ", ";
          permanentAddress += item.permanentAddressWardData?.name;
        }
        if (item.permanentAddressDistrictData) {
          permanentAddress += " - ";
          permanentAddress += item.permanentAddressDistrictData?.name;
        }
        if (item.permanentAddressProvinceData) {
          permanentAddress += " - ";
          permanentAddress += item.permanentAddressProvinceData?.name;
        }

        let currentAddress = item?.currentAddress || "";
        if (item.currentAddressWardData) {
          currentAddress += ", ";
          currentAddress += item.currentAddressWardData?.name;
        }
        if (item.currentAddressDistrictData) {
          currentAddress += " - ";
          currentAddress += item.currentAddressDistrictData?.name;
        }
        if (item.currentAddressProvinceData) {
          currentAddress += " - ";
          currentAddress += item.currentAddressProvinceData?.name;
        }

        let genderData = "-";
        if (item?.gender) {
          if (item?.gender === 1) {
            genderData = "Nam";
          } else if (item?.gender === 2) {
            genderData = "Nữ";
          } else {
            genderData = "Khác";
          }
        }

        let identityData = "CCCD/CMND";
        if (item?.identityNumber) {
          if (item?.identityNumber === 2) {
            identityData = "Hộ chiếu";
          } else {
            identityData = "CCCD/CMND";
          }
        }

        const isBusiness = Boolean(item?.isBusiness);

        // Thứ tự cột theo file mẫu của khách (CUSTOMER_EXCEL_COLUMNS ở
        // pages/customers/index.js). Các cột CCCD / ngày cấp / nơi cấp / địa chỉ
        // gộp chung cho cá nhân và doanh nghiệp.
        const baseRow = {
          name: item?.name || "-",
          genderLabel: !isBusiness ? genderData : "-",
          identificationNumber:
            (isBusiness ? item?.businessTaxCode : item?.identificationNumber) ||
            "-",
          dateOfIdentification:
            (isBusiness
              ? item?.businessRegistrationDate
              : item?.dateOfIdentification) || "-",
          placeOfIdentification:
            (isBusiness
              ? item?.businessRegistrationPlace
              : item?.placeOfIdentification) || "-",
          dateOfBirth: item?.dateOfBirth || "-",
          email: item?.email || "-",
          phone: item?.phone || "-",
          permanentAddress:
            (isBusiness ? item?.businessAddress : permanentAddress) || "-",
          currentAddress:
            (isBusiness ? item?.businessLocationAddress : currentAddress) ||
            "-",
          projectNames:
            Array.isArray(item?.wishlistDetail) && item.wishlistDetail.length
              ? item.wishlistDetail.map((e) => e.name).join(", ")
              : "-",
          identityTypeLabel: identityData,
          customerTypeName: item?.customerType?.name || "-",
          jobName: item?.job?.name || "-",
          customerKind: isBusiness ? "Doanh nghiệp" : "Cá nhân",
          representativePosition: item?.representativePosition || "-",
          representativeName: item?.representativeName || "-",
          representativeGenderLabel: isBusiness ? genderData : "-",
          representativeIdNumber: item?.representativeIdNumber || "-",
          representativeIdIssuedDate: item?.representativeIdIssuedDate || "-",
          representativeIdIssuedPlace: item?.representativeIdIssuedPlace || "-",
          representativeDateOfBirth: item?.representativeDateOfBirth || "-",
          representativeEmail: item?.email || "-",
          representativePhone: item?.phone || "-",
          bankAccount: item?.bankAccount || "-",
          bankName: item?.bankName || "-",
          nameAccount: item?.nameAccount || "-",
          employeeCode: item?.employee?.code || "-",
          employee: item?.employee?.fullName || "-",
          saleBlock: item?.employee?.saleBlock?.name || "-",
          saleArea: item?.employee?.saleArea?.name || "-",
          dateCreate: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
        };

        // luôn giữ dòng gốc của nhân viên tạo
        acc.push(baseRow);

        // thêm các dòng từ customer_shares, bỏ qua nếu trùng employee.code
        const employeeCode = item?.employee?.code;
        const customerShares = Array.isArray(item?.customer_shares)
          ? item.customer_shares
          : [];

        customerShares.forEach((share) => {
          if (employeeCode && share?.code && employeeCode === share.code)
            return;

          acc.push({
            ...baseRow,
            employeeCode: share?.code || "-",
            employee: share?.fullName || "-",
          });
        });

        return acc;
      }, []);

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
